import {
  Flex,
  Box,
  Heading,
  Spacer,
  Link,
  Tooltip,
  Image,
  Button,
  Icon,
} from "@chakra-ui/react";
import { useAppContext } from "../context/AppContext";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { FaHeadphones } from "react-icons/fa";
import NexusLogo from "../images/logo_nexus_consult.png";

function Header() {
  const { username } = useAppContext();
  const navigate = useNavigate();

  const handleStartAtendimento = () => {
    navigate("/atendimento");
  };

  return (
    <Flex
      p={{ base: 3, md: 5 }}
      bg="#007abe"
      color="white"
      alignItems="center"
      position="relative"
      minH="70px"
      boxShadow="md"
    >
      <Tooltip label="NEXUS CONSULTORIA" fontSize="md" placement="bottom">
        <Link
          href="https://www.nexusconsultoriams.com.br/"
          target="_blank"
          rel="noopener noreferrer"
          _hover={{ opacity: 0.8 }}
          transition="opacity 0.2s"
        >
          <Image
            src={NexusLogo}
            alt="Nexus Consultoria"
            borderRadius="full"
            boxSize={{ base: "80px", md: "115px" }}
            style={{ objectFit: "contain" }}
            cursor="pointer"
          />
        </Link>
      </Tooltip>

      <Spacer />

      <Box
        position="absolute"
        left="50%"
        transform="translateX(-50%)"
        display={{ base: "none", md: "flex" }}
        alignItems="center"
      >
        <Button
          onClick={handleStartAtendimento}
          leftIcon={<Icon as={FaHeadphones} />}
          bg="white"
          color="#007abe"
          size="md"
          borderRadius="lg"
          fontWeight="semibold"
          _hover={{
            bg: "#c0a316",
            color: "white",
            transform: "scale(1.05)",
          }}
          transition="all 0.2s"
          boxShadow="sm"
        >
          Iniciar Atendimento
        </Button>
      </Box>

      <Box>
        <RouterLink to="/home">
          <Heading
            size={{ base: "sm", md: "md" }}
            color="white"
            fontWeight="bold"
            _hover={{ opacity: 0.8 }}
            transition="opacity 0.2s"
          >
            CENZE
          </Heading>
        </RouterLink>
      </Box>
    </Flex>
  );
}

export default Header;
